import { useEffect } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useSearchAndShuffleContext } from './context';
import type { HookSavedData } from './types';

export const useSavedCards = ({
  useSavedData,
}: {
  useSavedData: HookSavedData;
}): void => {
  const { isLoggedOut } = useLoginState();
  const { data } = useSavedData();
  const { setSavedCards } = useSearchAndShuffleContext();

  useEffect(() => {
    if (data && !isLoggedOut) {
      setSavedCards(data);
    }
  }, [data]);
};
